<template>
  <a-select
    :value="value"
    mode="multiple"
    show-search
    :filter-option="false"
    :placeholder="placeholder"
    :not-found-content="loading ? undefined : null"
    allow-clear
    :max-tag-count="maxTagCount"
    style="width: 100%"
    @search="handleSearch"
    @change="handleChange"
    @dropdownVisibleChange="handleDropdownVisibleChange"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="u in mergedOptions" :key="u.id" :value="u.id">
      {{ formatUserLabel(u) }}
    </a-select-option>
  </a-select>
</template>

<script>
import { pageUser } from '@/api/biz/user'

export default {
  name: 'AppUserMultiSelect',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '输入邮箱/昵称/手机号/用户ID搜索并选择'
    },
    maxTagCount: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      loading: false,
      userOptions: [],
      selectedUsers: [],
      searchTimer: null
    }
  },
  computed: {
    mergedOptions() {
      const map = new Map()
      this.userOptions.forEach(u => map.set(u.id, u))
      this.selectedUsers.forEach(u => map.set(u.id, u))
      return Array.from(map.values())
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(ids) {
        this.syncSelectedUsers(ids || [])
      }
    }
  },
  methods: {
    formatUserLabel(u) {
      if (!u) return ''
      const parts = [`ID:${u.id}`]
      if (u.email) parts.push(u.email)
      if (u.nickname) parts.push(u.nickname)
      return parts.join(' · ')
    },
    buildQuery(keyword) {
      const kw = (keyword || '').trim()
      const query = { pageNum: 1, pageSize: 20, status: 1 }
      if (!kw) return query
      if (/^\d+$/.test(kw)) {
        query.id = Number(kw)
        return query
      }
      if (kw.includes('@')) {
        query.email = kw
        return query
      }
      if (/^\+?\d{3,}$/.test(kw)) {
        query.mobile = kw
        return query
      }
      query.nickname = kw
      return query
    },
    fetchUsers(keyword) {
      const kw = (keyword || '').trim()
      if (kw && kw.length < 2 && !/^\d+$/.test(kw)) {
        return
      }
      this.loading = true
      return pageUser(this.buildQuery(kw)).then(res => {
        this.userOptions = (res.data && res.data.records) || []
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch(keyword) {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.fetchUsers(keyword)
      }, 300)
    },
    handleDropdownVisibleChange(open) {
      if (open && this.userOptions.length === 0) {
        this.fetchUsers('')
      }
    },
    syncSelectedUsers(ids) {
      const idSet = new Set(ids)
      this.selectedUsers = this.selectedUsers.filter(u => idSet.has(u.id))
      ids.forEach(id => {
        if (!this.selectedUsers.some(u => u.id === id)) {
          const found = this.userOptions.find(u => u.id === id)
          this.selectedUsers.push(found || { id, email: '', nickname: '' })
        }
      })
    },
    handleChange(ids) {
      const nextIds = ids || []
      this.syncSelectedUsers(nextIds)
      nextIds.forEach(id => {
        const fromOptions = this.mergedOptions.find(u => u.id === id)
        if (fromOptions && !this.selectedUsers.some(u => u.id === id)) {
          this.selectedUsers.push(fromOptions)
        }
      })
      this.$emit('input', nextIds)
      this.$emit('change', nextIds)
    }
  },
  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer)
  }
}
</script>
